import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';

import { breakPoints } from '~/src/constants/breakpoints';

export const Button = styled(BaseButton)`
    margin-right: 5px;

    @media (max-width: ${breakPoints.mobile}) {
        width: 100%;
    }
`;
